export enum AwbStatusEnum {
  AVAILABLE = "AVAILABLE",
  USED = "USED",
}
